import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import React from "react";
import { Button } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var ButtonWithUnderlineText = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  &:hover,\n  &:focus {\n    color: ", " !important;\n  }\n"])), themeGet("colors.typography.linkHover"));
export var CTAButton = function CTAButton(props) {
  return ___EmotionJSX(ButtonWithUnderlineText, _extends({
    variant: "plain",
    padding: 0,
    textAlign: "left",
    textTransform: "none",
    fontSize: "xs",
    fontWeight: "bold",
    border: "none",
    color: "onePass.primary"
  }, props));
};